export const Sidebar = ({
    isOpen,
    onToggleSidebar,
    currentMenu,
    setMenu,
    role,
}) => {
    const menu = [
        {
            title: "Utama",
            icon: "home",
            onClick: () => {
                setMenu("utama");
                onToggleSidebar();
            },
        },
        ...(role === "admin"
            ? [
                  {
                      title: "Lembaga",
                      icon: "school",
                      onClick: () => {
                          setMenu("lembaga");
                          onToggleSidebar();
                      },
                  },
              ]
            : []),
        {
            title: "Prestasi",
            icon: "trophy",
            onClick: () => {
                setMenu("prestasi");
                onToggleSidebar();
            },
        },
    ];

    return (
        <div
            className={`fixed lg:static inset-y-0 left-0 bg-blue-500 w-64 p-4 transform duration-300 ease-in-out z-40 ${
                isOpen ? "translate-x-0" : "-translate-x-full"
            } lg:translate-x-0 lg:flex lg:flex-col`}>
            <div className="flex flex-row justify-between items-center mb-4">
                <img
                    src="/assets/6.jpg"
                    className="rounded-full w-[50px]"
                    alt="banner"
                />
                <h1 className="text-white font-bold m-0 p-0 ml-0 text-lg">
                    APRISLA
                </h1>
                <button
                    className="lg:hidden flex items-center justify-center text-white font-bold text-lg"
                    onClick={onToggleSidebar}>
                    <span className="material-symbols-outlined">close</span>
                </button>
            </div>
            <ul className="flex flex-col gap-2">
                {menu.map((item, index) => {
                    return (
                        <li
                            key={index}
                            onClick={item.onClick}
                            className={` ${
                                currentMenu === item.title.toLocaleLowerCase()
                                    ? "bg-blue-400"
                                    : ""
                            } text-white hover:bg-blue-400 px-4 py-2 rounded flex gap-3 items-center`}>
                            <span className="material-symbols-outlined">
                                {item.icon}
                            </span>
                            {item.title}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
